import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import AvatarField from './AvatarField';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'center',
    },
    avatar: {
        marginRight: theme.spacing(1),
    },
}));

const NameField = ({ record = {}, size }) => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <AvatarField
                className={classes.avatar}
                record={record}
                size={size}
            />
            { record.name }
        </div>
    );
};


NameField.defaultProps = {
    source: 'name',
    label: 'resources.users.fields.name',
};

export default NameField;
